"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTENT_TEXT = void 0;
const CONTENT_TEXT = exports.CONTENT_TEXT = 'content-text';
